(function () {
  'use strict';

  angular.module('app').component('bookingRelatedTransactions', bookingRelatedTransactions());

  function bookingRelatedTransactions() {
    return {
      bindings: {
        booking: '<',
        clientId: '<',
      },
      controller: BookingRelatedTransactionsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/components/booking-related-transactions/' +
        'booking-related-transactions.component.html',
    };
  }

  BookingRelatedTransactionsComponent.$inject = ['BookingService', 'RelatedTransactionService'];

  function BookingRelatedTransactionsComponent(BookingService, RelatedTransactionService) {
    let vm = this;

    // Methods
    vm.selectTransaction = selectTransaction;
    vm.openRelatedTransactionModal = openRelatedTransactionModal;

    vm.$onInit = function () {
      getRelatedTransactions();
    };

    function getRelatedTransactions() {
      vm.loadingRelatedTransactions = true;

      BookingService.getRelatedTransactions(vm.booking.id, vm.clientId).then(function (data) {
        vm.booking = data.booking;
        vm.incomingPrepayments = data.incomings;
        vm.invoices = data.invoices;

        vm.loadingRelatedTransactions = false;
      });
    }

    function selectTransaction(transaction, index) {
      vm.transactionSelected = transaction;
      transaction.show = !transaction.show;

      if (index !== undefined) {
        vm.indexSelected = index;
      }
    }

    function openRelatedTransactionModal(transaction) {
      RelatedTransactionService.openRelatedTransactionModal(transaction);
    }
  }
})();
